export function CartItemSkeleton() {
  return (
    <div className="overflow-hidden rounded-lg border border-zinc-100 bg-white p-3">
      <div className="flex items-stretch gap-3 sm:gap-4">
        <div className="h-24 w-20 animate-pulse rounded-lg bg-[#F0E0C7]/60 sm:h-31 sm:w-24" />
        <div className="flex flex-1 flex-col justify-between space-y-2 py-1">
          <div className="h-4 w-full animate-pulse rounded bg-[#F0E0C7]/60" />
          <div className="h-3 w-2/3 animate-pulse rounded bg-[#F0E0C7]/60" />
          <div className="h-5 w-20 animate-pulse rounded bg-[#F0E0C7]/60" />
        </div>
      </div>
    </div>
  );
}

export function AddressSkeleton() {
  return (
    <div className="space-y-3 rounded-xl border border-zinc-200 p-3">
      <div className="h-4 w-32 animate-pulse rounded bg-[#F0E0C7]/60" />
      <div className="h-4 w-48 animate-pulse rounded bg-[#F0E0C7]/60" />
      <div className="h-12 w-full animate-pulse rounded bg-[#F0E0C7]/60" />
    </div>
  );
}

export default function CartSkeleton({ itemCount = 2 }: { itemCount?: number }) {
  return (
    <div className="space-y-3">
      {Array.from({ length: itemCount }).map((_, index) => (
        <CartItemSkeleton key={`cart-item-${index}`} />
      ))}
    </div>
  );
}
